import React from "react";
import "./Footer.css"


function Footer() {
  return (
    <footer>
      <h5>Made by Scott Ray</h5>
    </footer>
  );
}

export default Footer;